module.exports = __webpack_public_path__ + "img/map-nl.16aa3692.png";